import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog/Dialog';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import IconButton from 'material-ui/IconButton';
import Typography from 'material-ui/Typography';
import {connect} from "react-redux";
import Slide from 'material-ui/transitions/Slide';
import {hideDetails} from "../actions/data";
import AppTheme from './AppTheme';
import Field from './Field';
import OccasionList from './OccasionList';
import {trimToTime} from "../service/timeUtils";

const EventDetailsDialog=({event,dispatch})=> {
   // console.log("details",event);
    const details =event && event.details ? (typeof event.details === 'string' ? JSON.parse(event.details) : event.details) : undefined;
    console.log(details);
    const fields=details?
        <div>{Object.keys(details)
            .filter((key)=>(key!=='occasions'))
            .map((key)=>(<Field object={details} field={key} key={key}/>))}</div>
        :null;

    function getCaption(event) {
        if(!event) return;
        return 'Детализация элемента игры: ' + (event.type ? '|'+event.type + '| ' : "")
            + (event.target ? '|' + event.target + '| ' : "") + 'время: ' + trimToTime(event.startTime);
    }

    return (
        <AppTheme>
        <Dialog
            open={!!(details)}
            aria-labelledby="event details">
            <AppBar position="static" color="secondary">
                <Toolbar>
                    <IconButton color="secondary" onClick={()=>{dispatch(hideDetails())}} aria-label="Close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                            <path  fill="#7a7a7a" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
                    </IconButton>
                    <Typography variant="title" color="primary" className='details-dialog-flex'>
                        {getCaption(event)}
                    </Typography>
                </Toolbar>
            </AppBar>
            <div className='dialog-content'>
                {fields ?fields:''}
                {details && details.occasions && details.occasions.length>0 ?
                    <OccasionList occasions={details.occasions}/>:''}
            </div>
        </Dialog>
        </AppTheme>
    );
};

const mapStateToProps=(state)=>({event:state.data.event});
const ConnectedEventDetailsDialog=connect(mapStateToProps)(EventDetailsDialog);
export default ConnectedEventDetailsDialog;